import { createRouter, createWebHistory } from 'vue-router'
import DetailsPage from '@/views/details_page/details_page.vue'
import OpponentPage from '@/views/opponent_page/opponent_page.vue'
import FrontPage from '@/views/front_page/front_page.vue'
import AllPage from '@/views/all_page/front_page.vue'
import AllWinPage from '@/views/allwin_page/front_page.vue'
import YearPage from '@/views/year_page/front_page.vue'
import YearWinPage from '@/views/yearwin_page/front_page.vue'
import MatchPage from '@/views/match_page/match_page.vue'
import AreaPage from '@/views/area_page/area_page.vue'
import WinRatePage from '@/views/win_ratepage_page/win_ratepage_page.vue'
import InactivePage from '@/views/inactive_page/inactive_page.vue'
import UneighteenPage from '@/views/uneighteen_page/uneighteen_page.vue'
import UnfourteenPage from '@/views/unfourteen_page/uneighteen_page.vue'
import EchartPage from '@/views/echart_page/echart_page.vue'


const router = createRouter({
    history: createWebHistory(process.env.NODE_ENV === 'production' ? '/' : '/'),
     routes: [
     {
        path: '/',
        name: 'FrontPage',
         component: FrontPage
        },
    {
        path: '/details',
        name: 'DetailsPage',
        component: DetailsPage
    },
    {
        path: '/opponent',
        name: 'OpponentPage',
        component: OpponentPage
    },
    {
        path: '/allpage',
        name: 'AllPage',
        component: AllPage
    },
    {
        path: '/winpage',
        name: 'AllWinPage',
        component: AllWinPage
    },
    {
        path: '/yearpage',
        name: 'YearPage',
        component: YearPage
    },
    {
        path: '/yearwinpage',
        name: 'YearWinPage',
        component: YearWinPage
    },
    {
        path: '/matchpage',
        name: 'MatchPage',
        component: MatchPage
    },
    {
        path: '/areapage',
        name: 'AreaPage',
        component: AreaPage
    },
    {
        path: '/winratepage',
        name: 'WinRatePage',
        component: WinRatePage
    },
    {
        path: '/inactivepage',
        name: 'InactivePage',
        component: InactivePage
    },
    {
        path: '/uneighteenpage',
        name: 'UneighteenPage',
        component: UneighteenPage
    },
    {
        path: '/unfourteenpage',
        name: 'UnfourteenPage',
        component: UnfourteenPage
    },
    {
        path: '/echartpage',
        name: 'echartpage',
        component: EchartPage
    }
 ]
});

export default router 